import React from 'react';

import { flowItemTitle, flowItemTypeEnum } from '../utils';
import styled from 'styled-components';

const ProcessHttpMessageTaskIcon = require('../svg/ProcessHttpMessageTaskIcon.svg').default;
const ProcessSubDecisionTaskIcon = require('../svg/ProcessSubDecisionTaskIcon.svg').default;
const ProcessSubProcessTaskIcon = require('../svg/ProcessSubProcessTaskIcon.svg').default;
const ProcessSubProcessStartTaskIcon = require('../svg/ProcessSubProcessStartTaskIcon.svg').default;
const ProcessMessageQueueTaskIcon = require('../svg/ProcessMessageQueueTaskIcon.svg').default;
const ProcessSignalIcon = require('../svg/ProcessSignalIcon.svg').default;

const ProcessRpaIcon = require('../svg/ProcessRpaIcon.svg').default;
const ProcessRpaStartIcon = require('../svg/ProcessRpaStartIcon.svg').default;
const ProcessInvokeModelInstanceIcon = require('../svg/ProcessInvokeModelInstanceIcon.svg').default;
const ProcessMessageResponseTaskIcon = require('../svg/ProcessMessageResponseTaskIcon.svg').default;

const ProcessScriptTaskIcon = require('../svg/ProcessScriptTaskIcon.svg').default;
const ProcessParameterTableTaskIcon = require('../svg/ProcessParameterTableTaskIcon.svg').default;

const iconsMapper = {
    [flowItemTypeEnum.PROCESS_SCRIPT_TASK]: ProcessScriptTaskIcon,
    [flowItemTypeEnum.PROCESS_MESSAGE_RESPONSE_TASK]: ProcessMessageResponseTaskIcon,
    [flowItemTypeEnum.PROCESS_HTTP_MESSAGE_TASK]: ProcessHttpMessageTaskIcon,
    [flowItemTypeEnum.PROCESS_SUB_DECISION_TASK]: ProcessSubDecisionTaskIcon,
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_TASK]: ProcessSubProcessTaskIcon,
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_START_TASK]: ProcessSubProcessStartTaskIcon,
    [flowItemTypeEnum.PROCESS_MESSAGE_QUEUE_TASK]: ProcessMessageQueueTaskIcon,
    [flowItemTypeEnum.PROCESS_CUSTOM_COMPONENTS]: ProcessSignalIcon,
    [flowItemTypeEnum.PROCESS_SIGNAL_COMPONENTS]: ProcessSignalIcon,
    [flowItemTypeEnum.PROCESS_RPA]: ProcessRpaIcon,
    [flowItemTypeEnum.PROCESS_RPA_START]: ProcessRpaStartIcon,
    [flowItemTypeEnum.PROCESS_INVOKE_MODEL_INSTANCE]: ProcessInvokeModelInstanceIcon,
    [flowItemTypeEnum.PROCESS_PARAMETERS_TABLE_TASK]: ProcessParameterTableTaskIcon,
};

type ItemStyleProps = {
    selected: boolean;
};

const ItemStyle = styled.div.attrs<ItemStyleProps>((props: ItemStyleProps) => ({
    className: `${props.selected ? 'selected' : ''}`,
}))`
    &&& {
        width: 33px;
        height: 28px;
        border: 0.6px solid #d9d9d9;
        border-radius: 8px;

        cursor: pointer;

        &.selected {
            border-color: #8266c9;
        }

        .icon-wrapper {
            height: 100%;
        }

        .item-icon {
            width: 100%;
            height: 100%;
        }

        &:hover {
            border-color: #8266c9;
        }
    }
`;

const MarginLeftSeparator = styled.div`
    &&& {
        margin-left: 7px;
    }
`;

export type ItemProps = {
    type: (typeof flowItemTypeEnum)[keyof typeof flowItemTypeEnum];
    selected?: boolean;
    disableSeparator?: boolean;
    onSelect: (type: (typeof flowItemTypeEnum)[keyof typeof flowItemTypeEnum]) => void;
};

export const Item = ({ type, selected = false, disableSeparator = false, onSelect }: ItemProps) => {
    const Icon = iconsMapper[type];

    return (
        <>
            <ItemStyle selected={selected ?? false} onClick={() => onSelect(type)} title={flowItemTitle[type] || ''}>
                <div className="icon-wrapper">
                    <Icon className="item-icon" />
                </div>
            </ItemStyle>
            {!disableSeparator && <MarginLeftSeparator />}
        </>
    );
};
